// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sy_gw","content":"styles_content__2dGA1","row":"styles_row__1fU0F","footer":"styles_footer__2N36l","phraseLength":"styles_phraseLength__-_88c"};